import { render, staticRenderFns } from "./TuitionManagement.vue?vue&type=template&id=2c133909&scoped=true"
import script from "./TuitionManagement.vue?vue&type=script&lang=js"
export * from "./TuitionManagement.vue?vue&type=script&lang=js"
import style0 from "./TuitionManagement.vue?vue&type=style&index=0&id=2c133909&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c133909",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c133909')) {
      api.createRecord('2c133909', component.options)
    } else {
      api.reload('2c133909', component.options)
    }
    module.hot.accept("./TuitionManagement.vue?vue&type=template&id=2c133909&scoped=true", function () {
      api.rerender('2c133909', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionManagement/TuitionManagement.vue"
export default component.exports